import { init, RematchRootState } from '@rematch/core';
import selectPlugin from '@rematch/select';
import * as Sentry from '@sentry/browser';
import createSentryMiddleware from 'redux-sentry-middleware';

import { chat } from '../rematch-models/chat';
import { featureFlags } from '../rematch-models/featureFlags';
import { network } from '../rematch-models/network';
import { partners } from '../rematch-models/partners';
import { presence } from '../rematch-models/presence';
import { resources } from '../rematch-models/resources';
import { router } from '../rematch-models/router';
import { snackbarNotifier } from '../rematch-models/snackbarNotifier';
import { user } from '../rematch-models/user';

const sentryMiddleware = createSentryMiddleware(Sentry as any);

const models = {
  chat,
  featureFlags,
  network,
  presence,
  resources,
  router,
  snackbarNotifier,
  user,
  partners,
};

export const store = init({
  plugins: [selectPlugin()],
  models,
  redux: {
    middlewares: [sentryMiddleware],
  },
});

export type Store = typeof store;
export type Dispatch = typeof store.dispatch;
export type RematchModels = RematchRootState<typeof models>;
export type RootState = RematchModels;
